module.exports = __webpack_public_path__ + "static/media/n18.4413d0a1.jpg";